import { LoadingSpin, PageContainer } from '@/components/common';
import { SurveyApiType } from '@/configs';
import { useSurvey } from '@/hooks';
import { Alert } from 'antd';
import { Flex } from '@/components/common';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SurveysList from '../SurveysList';

export const ElectionCandidacy = () => {

  const [t] = useTranslation(['common', 'survey']);
  const { surveys, fetchSurvey, loading } = useSurvey();
  const type = SurveyApiType.ElectionCandidacy;

  useEffect(() => {
    fetchSurvey();
  }, []);

  const electionCandidacySurveys = surveys?.filter((survey) => survey.type === type) ?? [];
  const hasElectionCandidacy = electionCandidacySurveys.length > 0;

  if (loading) {
    return <LoadingSpin fillHeight />;
  }

  if (!hasElectionCandidacy) {
    return (
      <PageContainer title={t(`common:labels.survey-${type}`)}>
        <Alert type="warning" className="flex mx-auto max-h-16 mt-2 text-center" message={t(`common:messages.survey-empty-${type}`)} />
      </PageContainer>
    );
  }

  return (
    <PageContainer title={t(`common:labels.survey-${type}`)}>
      <Flex direction="column" className="max-w-xl mx-auto">
        <SurveysList
          surveys={electionCandidacySurveys}
          onIgnore={() => { }}
          showIgnore={false}
          extraSpace
        />
      </Flex>
    </PageContainer>
  );
};

export default ElectionCandidacy;
